import {Dropdown} from "react-bootstrap";
import SettingsIcon from "@mui/icons-material/Settings";
import React from "react";
import PopupEditBoleto from "./PopupEditBoleto";
import PopupCancelBoleto from "./PopupCancelBoleto";
import PopupListUpdates from "./PopupListUpdates";
import PopupNotify from "./PopupNotify";
import PopupEditNegativationData from "./PopupEditNegativationData";
import PopupEditProtestData from "./PopupEditProtestData";
import PopupGenerateDuplicate from "../../Order/Components/PopupGenerateDuplicate";


export default function BoletoActions({item, setLoadData}) {

    return <Dropdown drop='down-centered'>
        <Dropdown.Toggle
            variant="secondary"
            disabled={false}
        >
            Ações &nbsp;
            <SettingsIcon fontSize="medium"/>
        </Dropdown.Toggle>

        <Dropdown.Menu>
            {item.alteracaoVencimentoDto?.length > 0 &&
                <PopupListUpdates item={item}/>
            }

            {(item.status === 'CRIADO' || item.status === 'VENCIDO') && <>
                <PopupEditBoleto setLoadData={setLoadData} item={item}/>
                <PopupNotify id={item.id}/>
                <PopupCancelBoleto setLoadData={setLoadData} item={item}/>
            </>}

            <PopupEditNegativationData setLoadData={setLoadData} item={item}/>
            <PopupEditProtestData setLoadData={setLoadData} item={item}/>
        </Dropdown.Menu>

    </Dropdown>
}